//import { required, email, phone, url } from './validationRules';

// 必要なフィールドだけを動的に取得する関数
export const getFields = (fields, fieldsToInclude) => {
    return fields.filter(field => fieldsToInclude.includes(field.name));
};


// 検索フィールド定義
export const searchFields = [
    /* orders */
    {
        name: 'dates',
        type: 'date',
        label: '期間指定',
    },
    {
        name: 'order_numbers',
        type: 'textarea',
        label: '注文番号',
        placeholder: '改行で複数検索できます',
    },
    {
        name: 'estimate_numbers',
        type: 'textarea',
        label: '見積番号',
        placeholder: '改行で複数検索できます',
    },
    /* clients */
    {
        name: 'is_pending',
        type: 'checkbox',
        label: '申請中を表示する',
    },
    {
        name: 'client_code',
        type: 'text',
        label: '取引先コード',
    },
    {
        name: 'client_name',
        type: 'text',
        label: '会社名',
    },
    /* products */
    {
        name: 'keywords',
        type: 'text',
        label: '商品コード、品番、商品名、JAN',
    },
    {
        name: 'sku',
        type: 'textarea',
        label: 'SKU',
    },
    {
        name: 'product_name',
        type: 'text',
        label: '商品名',
    },
    {
        name: 'category_id',
        type: 'select',
        label: 'カテゴリー',
    },
    {
        name: 'item_code',
        type: 'text',
        label: 'アイテムコード',
    },
    {
        name: 'item_name',
        type: 'text',
        label: 'アイテム名',
    },
    {
        name: 'supplier_code',
        type: 'text',
        label: '仕入れ先コード',
    },
    {
        name: 'supplier_name',
        type: 'text',
        label: '仕入れ先名',
    },
    /*{
        name: 'is_baseline_stock',
        type: 'checkbox',
        label: '基準在庫以下',
    },
    {
        name: 'is_min_stock_level',
        type: 'checkbox',
        label: '最低在庫以下',
    },
    {
        name: 'category',
        type: 'category',
    },*/
];

// 顧客情報のフィールド
export const clientFields = [
    /*{
        label: '取引先コード',
        name: 'client_code',
        type: 'text',
        placeholder: '12345678',
        inputProps: { maxLength: 50 },
        validation: {
            required: '取引先コードは必須です',
            maxLength: { value: 50, message: '50文字以内で入力してください' },
            pattern: { value: /^[A-Za-z0-9\-]+$/, message: '半角英数字とハイフンのみ使用可能です' },
        },
    },*/
    {
        label: '顧客名',
        name: 'client_name',
        type: 'text',
        placeholder: '株式会社〇〇',
        inputProps: { maxLength: 100 },
        validation: {
            required: '顧客名は必須です',
            maxLength: { value: 100, message: '100文字以内で入力してください' },
        },
    },
    {
        label: '営業所名',
        name: 'branch_name',
        type: 'text',
        placeholder: '東京営業所（ない場合は-を入力）',
        inputProps: { maxLength: 100 },
        validation: {
            required: '営業所名は必須です',
            maxLength: { value: 100, message: '100文字以内で入力してください' },
        },
    },
    {
        label: '郵便番号',
        name: 'postal_code',
        type: 'text',
        placeholder: '1234567',
        inputProps: { maxLength: 8 },
        validation: {
            required: '郵便番号は必須です',
            pattern: { value: /^\d{3}\d{4}$/, message: '郵便番号はXXXXXXX形式で入力してください' },
        },
    },
    {
        label: '電話番号',
        name: 'client_phone',
        type: 'tel',
        placeholder: '03-1234-5678',
        inputProps: { maxLength: 20 },
        validation: {
            required: '電話番号は必須です',
            pattern: { value: /^(?:\+?\d{1,4}[-\s]?)?0?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{4}$/, message: '電話番号の形式が正しくありません' },
        },
    },
    {
        label: 'FAX番号',
        name: 'client_fax',
        type: 'tel',
        placeholder: '03-1234-5679',
        inputProps: { maxLength: 20 },
        validation: {
            pattern: { value: /^(?:\+?\d{1,4}[-\s]?)?0?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{4}$/, message: 'FAX番号の形式が正しくありません' },
        },
    },
    {
        label: '業種',
        name: 'industry_id',
        type: 'select',
        placeholder: '業種を選択してください',
        validation: { required: '業種は必須です' },
    },
    {
        label: '事業内容',
        name: 'business_description',
        type: 'textarea',
        placeholder: '事業内容を入力してください',
        inputProps: { maxLength: 2000 },
        validation: { maxLength: { value: 2000, message: '500文字以内で入力してください' } },
    },
    {
        label: 'WebサイトURL',
        name: 'website_url',
        type: 'url',
        placeholder: 'https://example.com',
        inputProps: { maxLength: 255 },
        validation: {
            pattern: { value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/, message: 'URL形式が正しくありません' },
            maxLength: { value: 255, message: '255文字以内で入力してください' },
        },
    },
    /*{
        label: '支払い方法',
        name: 'payment_method_id',
        type: 'select',
        placeholder: '選択してください',
    },*/
    {
        label: '支払い条件',
        name: 'payment_terms',
        type: 'text',
        placeholder: 'XX締め翌XX日払い',
        inputProps: { maxLength: 50 },
        validation: { maxLength: { value: 50, message: '50文字以内で入力してください' } },
    },
    /*{
        label: '仕切り率',
        name: 'credit_terms',
        type: 'number',
        placeholder: '100',
        inputProps: { min: 0, max: 100 },
        validation: {
            required: '仕切り率は必須です',
            min: { value: 0, message: '0以上で入力してください' },
            max: { value: 100, message: '100以下で入力してください' },
        },
    },*/
];
// 担当者情報のフィールド
/*
export const contactFields = [
    { label: '担当者名', name: 'client_contact_name', type: 'text', placeholder: '山田 太郎', validation: required('担当者名') },
    { label: 'メールアドレス', name: 'client_contact_email', type: 'email', placeholder: 'taro@example.com', validation: email(true, 'メールアドレス') },
    { label: '電話番号', name: 'client_contact_phone', type: 'tel', placeholder: '090-1234-5678', validation: phone(true, '電話番号') },
];*/


// 注文データのフィールド
/*
export const orderFields = [
    { label: '郵便番号', name: 'postal_code', type: 'text' },
    { label: '都道府県', name: 'state', type: 'text' },
    { label: '住所', name: 'address_line', type: 'text' },
    { label: '配送日', name: 'delivery_date', type: 'date' },
    { label: '合計金額', name: 'total_amount', type: 'number' },
    { label: '商品情報', name: 'items', type: 'array' } // 注文アイテムの配列
];
*/
// 商品情報のフィールド
export const productFields = [
    { label: '商品ID', name: 'product_id', type: 'text' },
    { label: '商品コード', name: 'product_code', type: 'text' },
    { label: 'JANコード', name: 'jan_code', type: 'text' },
    { label: '商品名', name: 'product_name', type: 'text' },
    { label: '商品カテゴリID', name: 'category_id', type: 'number' },
    { label: 'ブランド名', name: 'brand_name', type: 'text' },
    { label: '商品説明', name: 'product_description', type: 'textarea' },
    { label: '価格', name: 'price', type: 'number' },
    { label: '仕入価格', name: 'purchase_price', type: 'number' },
    { label: '最小発注数', name: 'min_order_quantity', type: 'number' },
    { label: '商品登録日時', name: 'created_at', type: 'date' },
    { label: '最終更新日時', name: 'updated_at', type: 'date' },
    { label: '販売状況', name: 'sale_status', type: 'select' },
    { label: '商品詳細', name: 'product_detail', type: 'textarea' }
];

// 自社情報のフィールド
export const settingCompanyFields = [
    { label: '運営責任者', name: 'representative', type: 'text', placeholder: '運営責任者を入力', maxLength: 100 },
    { label: '商品代金以外の必要料金', name: 'additional_fees', type: 'textarea', placeholder: '商品代金以外の必要料金を入力', maxLength: 2000 },
    { label: '不良品対応', name: 'defective_product_policy', type: 'textarea', placeholder: '不良品対応を入力', maxLength: 2000 },
    { label: '返品送料', name: 'return_shipping_policy', type: 'textarea', placeholder: '返品送料を入力', maxLength: 2000 },
    { label: '返品・キャンセルについて', name: 'return_cancel_policy', type: 'textarea', placeholder: '返品・キャンセルについてを入力', maxLength: 2000 },
    { label: '商品引き渡し時期', name: 'delivery_time', type: 'textarea', placeholder: '商品引き渡し時期を入力', maxLength: 2000 },
    { label: '支払い方法', name: 'payment_method', type: 'textarea', placeholder: '支払い方法を入力', maxLength: 2000 },
    { label: 'お支払期限', name: 'payment_deadline', type: 'textarea', placeholder: 'お支払期限を入力', maxLength: 2000 },
    { label: '連絡先電話番号', name: 'contact_phone_number', type: 'tel', placeholder: '連絡先電話番号を入力', maxLength: 20 },
    { label: '連絡先メールアドレス', name: 'contact_email_address', type: 'email', placeholder: 'abc@example.com', maxLength: 255 },
    { label: '営業時間', name: 'business_hours', type: 'text', placeholder: '営業時間を入力', maxLength: 255 },
];

export const accountFields = [
    {
        label: '銀行名',
        name: 'bank_name',
        type: 'text',
        placeholder: '例：サンプル銀行',
        maxLength: 255,
        validation: {
            required: '銀行名は必須です',
            maxLength: { value: 255, message: '255文字以内で入力してください' }
        }
    },
    {
        label: '支店名',
        name: 'bank_branch_name',
        type: 'text',
        placeholder: '例：サンプル支店',
        maxLength: 255,
        validation: {
            maxLength: { value: 255, message: '255文字以内で入力してください' }
        }
    },
    {
        label: '口座種別',
        name: 'bank_account_type',
        type: 'text',
        placeholder: '例：普通 / 当座',
        maxLength: 50,
        validation: {
            required: '口座種別は必須です',
            maxLength: { value: 50, message: '50文字以内で入力してください' }
        }
    },
    {
        label: '口座番号',
        name: 'bank_account_number',
        type: 'text',
        placeholder: '例：1234567',
        maxLength: 50,
        validation: {
            required: '口座番号は必須です',
            maxLength: {
                value: 50, message: '50文字以内で入力してください',
            },
            pattern: {
                value: /^[0-9\-]+$/,
                message: '数字とハイフンのみ入力できます'
            }
        }
    },
    {
        label: '口座名義',
        name: 'bank_account_holder',
        type: 'text',
        placeholder: '例：カ）テンデネック',
        maxLength: 255,
        validation: {
            required: '口座名義は必須です',
            maxLength: { value: 255, message: '255文字以内で入力してください' }
        }
    },
    {
        label: '表示順',
        name: 'sort_order',
        type: 'number',
        placeholder: '1',
        validation: {
            min: { value: 0, message: '0以上で入力してください' },
            max: { value: 9999, message: '9999以下で入力してください' },
            pattern: {
                value: /^[0-9]+$/,
                message: '半角数字のみ入力できます'
            }
        }
    }
];
